import script from "./DomainsSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainsSearch.vue?vue&type=script&setup=true&lang=js"

import "./DomainsSearch.vue?vue&type=style&index=0&id=03e26915&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03e26915"]])

export default __exports__